import { IKeHoachToanKhoaActionTypes } from "../../action-types/ke-hoach/IKeHoachToanKhoaActions"
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase"
import { IKeHoachToanKhoaReducer } from "../../reducer-model/ke-hoach/IKeHoachToanKhoaReducer"

const iniState: IKeHoachToanKhoaReducer = {
    filter: {
        id_he: 0,
        khoa_hoc: 0,
        id_chuyen_nganh: 0,
    },
    keHoachMons: [],
    status: eReducerStatusBase.is_not_initialization,
    isShowAddMonModal: false,
    isShowUpdateNgayHocThiAutoModal: false,
    autoDateWeekParams: {
        soTuanHocMoiMon: 8,
        soTuanSauKetThucDenThi: 3,
        soTuanSauThiDenBatDauKySau: 1,
    },
    selectionIds: [],
} as IKeHoachToanKhoaReducer
export const keHoachToanKhoaReducer = (state: IKeHoachToanKhoaReducer = iniState, action: IKeHoachToanKhoaActionTypes): IKeHoachToanKhoaReducer => {
    switch (action.type) {
        case "KE_HOACH_TOAN_KHOA_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            }
        case "KE_HOACH_TOAN_KHOA_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "KE_HOACH_TOAN_KHOA_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachMons: action.payload
            }
        case "KE_HOACH_TOAN_KHOA_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachMons: []
            }
        
        case "KE_HOACH_TOAN_KHOA_UPDATE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "KE_HOACH_TOAN_KHOA_UPDATE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                // keHoachMons: action.payload,
                isShowUpdateNgayHocThiAutoModal: false
            }
        case "KE_HOACH_TOAN_KHOA_UPDATE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachMons: []
            }
        case "KE_HOACH_TOAN_KHOA_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "KE_HOACH_TOAN_KHOA_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachMons: [...state.keHoachMons.filter(x => !action.payload.includes(x.id_kh_mon))]
            }
        case "KE_HOACH_TOAN_KHOA_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachMons: []
            }
        case "KE_HOACH_TOAN_KHOA_SHOW_ADD_MON_MODAL":
            return {
                ...state,
                isShowAddMonModal: true
            }
        case "KE_HOACH_TOAN_KHOA_CLOSE_ADD_MON_MODAL":
            return {
                ...state,
                isShowAddMonModal: false
            }
        case "KE_HOACH_TOAN_KHOA_ADDING_MONHOC_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "KE_HOACH_TOAN_KHOA_ADDING_MONHOC_SUCCESS":
            return {
                ...state,   
                status: eReducerStatusBase.is_completed,
                isShowAddMonModal: false
            }
        case "KE_HOACH_TOAN_KHOA_ADDING_MONHOC_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                isShowAddMonModal: false
            }
        case "KE_HOACH_TOAN_KHOA_SHOW_UPDATE_NGAY_HOC_THI_AUTO_MODAL":
            return {
                ...state,
                isShowUpdateNgayHocThiAutoModal: true
            }
        case "KE_HOACH_TOAN_KHOA_CLOSE_UPDATE_NGAY_HOC_THI_AUTO_MODAL":
            return {
                ...state,
                isShowUpdateNgayHocThiAutoModal: false
            }
        case "KE_HOACH_TOAN_KHOA_CHANGE_AUTO_DATE_WEEK_PARAMS":
            return {
                ...state,
                autoDateWeekParams: action.payload,
            }
        case "KE_HOACH_TOAN_KHOA_SELECTION_IDS":
            return {
                ...state,
                selectionIds: action.payload,
            }
        case "KE_HOACH_TOAN_KHOA_CREATE_LOP_TC_AUTO_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "KE_HOACH_TOAN_KHOA_CREATE_LOP_TC_AUTO_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                selectionIds: []
            }
        case "KE_HOACH_TOAN_KHOA_CREATE_LOP_TC_AUTO_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        default:
            return state
    }
}